import useCommonSearchQuery from "@repo/shopify/queries/useSearchQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useSearch() {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonSearchQuery({
    lang,
    openToast,
  });
}
